/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Toast_Copilot_ReaddedInputs */



/**
* | output |
* | --- |
* | "Compliance Copilot re-added." |
*
* @param {Sub_Addons_Toast_Copilot_ReaddedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_toast_copilot_readded = /** @type {((inputs?: Sub_Addons_Toast_Copilot_ReaddedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Toast_Copilot_ReaddedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance Copilot erneut hinzugefügt.")
	return /** @type {LocalizedString} */ ("Compliance Copilot re-added.")
});